import { render, staticRenderFns } from "./PerfScorePage.vue?vue&type=template&id=684fa723"
import script from "./PerfScorePage.vue?vue&type=script&lang=js"
export * from "./PerfScorePage.vue?vue&type=script&lang=js"
import style0 from "./PerfScorePage.vue?vue&type=style&index=0&id=684fa723&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports